import {formatSortConfig} from './formatSortConfig';

// Порядок форматов выдачи — общий для одиночного видео (ItemResultDefault.vue)
// и списка качеств карточки плейлиста (PlaylistCard.vue): видео со звуком по
// formatSortConfig.video, затем аудио, затем видео без звука; внутри группы —
// по убыванию качества. Дубли (тот же тип, звук, ext, качество, имя) убираются.

export function strToInt(quality) {
  if (!quality) return 0;
  if (typeof quality === 'number') return quality;

  const direct = parseInt(quality, 10);
  if (!isNaN(direct)) return direct;

  const match = String(quality).toLowerCase().match(/(\d{3,4})p/);
  return match ? parseInt(match[1], 10) : 0;
}

export function removeDuplicates(formats) {
  const unique = new Set();

  return (formats || []).filter((format) => {
    const key = [
      format?.type || '',
      format?.no_audio ? '1' : '0',
      format?.ext || '',
      format?.quality || '',
      format?.name || '',
      format?.subname || '',
    ].join('|');

    if (unique.has(key)) return false;
    unique.add(key);
    return true;
  });
}

export function getSortCategory(item) {
  const type = (item?.type || item?.ext || '').toLowerCase();

  // 1) Видео с аудио (no_audio = false)
  if (!item?.no_audio) {
    const videoIndex = formatSortConfig.video.findIndex(v => type.includes(v));
    if (videoIndex !== -1) return videoIndex;
  }

  // 2) Аудио
  const audioIndex = formatSortConfig.audio.findIndex(a => type.includes(a));
  if (audioIndex !== -1) return 100 + audioIndex;

  // 3) Видео без аудио
  if (item?.no_audio) {
    const videoIndex = formatSortConfig.video.findIndex(v => type.includes(v));
    if (videoIndex !== -1) return 200 + videoIndex;
  }

  // 4) Остальные
  return 999;
}

export function sortFormats(formats) {
  const unique = removeDuplicates(formats);

  return [...unique].sort((a, b) => {
    const categoryA = getSortCategory(a);
    const categoryB = getSortCategory(b);

    if (categoryA !== categoryB) return categoryA - categoryB;

    const qualityA = a.qualityNumber ?? strToInt(a.quality);
    const qualityB = b.qualityNumber ?? strToInt(b.quality);

    return qualityB - qualityA;
  });
}
